module.exports = __webpack_public_path__ + "img/progreso.4c620e10.png";